import { BODY_STYLES_EVENTS } from '../event_bus_modules/body_styles';

$(() => {
  const $body = $('body');

  const disableScroll = () => {
    $body.addClass('no-scroll');
  };

  const enableScroll = () => {
    $body.removeClass('no-scroll');
  };

  const disableScrollMobile = () => {
    $body.addClass('no-scroll-mobile');
  };

  const enableScrollMobile = () => {
    $body.removeClass('no-scroll-mobile');
  };

  EVENT_BUS.on(BODY_STYLES_EVENTS.DISABLE_SCROLL, disableScroll);
  EVENT_BUS.on(BODY_STYLES_EVENTS.ENABLE_SCROLL, enableScroll);
  EVENT_BUS.on(BODY_STYLES_EVENTS.DISABLE_SCROLL_MOBILE, disableScrollMobile);
  EVENT_BUS.on(BODY_STYLES_EVENTS.ENABLE_SCROLL_MOBILE, enableScrollMobile);
});
